export default {
    CHANGE_MAIN_MENU(state, mainMenu) {
        state.mainMenu = mainMenu;
    },
    CHANGE_MENU_HIDE(state, menuHide) {
        state.menuHide = menuHide;
    },
    INIT_MENUS(state, menus) {
        state.menus = menus;
    },
    INIT_MENU_GROUPS(state, groups) {
        state.menuGroups = groups;
    },
    CHANGE_SUBGROUPS(state, subGroups) {
        state.subGroups = subGroups;
    },
    INIT_LOGIN_USER(state, user) {
        state.loginUser = user;
        if(!state.project && user.project) {
            state.project = user.project;
        }
    },
    INIT_LOGIN_CUSTOMER(state, customer) {
        state.loginCust = customer;
    },
    INIT_LOGIN_TYPE(state, loginType) {
        state.loginType = loginType;
    },
    INIT_CURRENT_PROJECT(state, project) {
        state.project = project;
        let project_id = _.get(project, 'project_id');
        if(localStorage && project_id) {
            localStorage.setItem("project_id", project_id)
        }
    },
    CHANGE_MENUCOLLAPSE(state, menuCollapse) {
        if(typeof menuCollapse === 'undefined') {
            state.menuCollapse = !state.menuCollapse;
        } else {
            state.menuCollapse = menuCollapse;
        }
    },
    CHANGE_PROJECT(state, project) {
        state.project = project;
    },
    INIT_TOKEN(state, token) {
        state.token = token;
    },
    INIT_LAYOUT(state, layoutComp) {
        state.layoutComp = layoutComp;
    }
}
